import React from 'react';
import {BooleanInput, Create, SimpleForm, TextInput} from 'react-admin';

const FoodTagCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm
                redirect="show"
            >
                <TextInput source="name" />
                <BooleanInput source="deleted" />
            </SimpleForm>
        </Create>
    );
};

export default FoodTagCreate;